module.exports = __webpack_public_path__ + "images/4c94c9d.png";